import React from 'react';

import MultiPageForm from "../Base/ReactMultiPageForm";
import LexicalRichTextEditor from "../UI/LexicalRichTextEditor";

export default class ChildProgressReviewFeedback extends MultiPageForm
{
	constructor(props) 
	{
		super(props);

		if ( this.props.feedback != null )
		{
			this.state.feedback = this.props.feedback ;
		}

        if ( this.props.html != null )
        {
            this.state.html = this.props.html ;
        }

        this.keyCount = 1 ;

        this.onLeave = this.onLeave.bind(this) ;
	}

	updateReviewRecords ( reviewData) 
	{
		let data = { review_data: reviewData } ;
		
    	$.ajax({
  		  type: 'PUT',
  		  url: Globals.APIFolder + '/children/' + reviewData.child_id + '/review',
  		  data: data,
  		  success:(data)=>
		  {
			if ( checkError(data))
			{
				this.setDirty ( false ) ;
			}
  		  },
  		  error:function(jqXHR, textStatus, error)
		  {
  		    handleAjaxError( jqXHR, textStatus, error);
  		  }
  		});
	}

	getFormData()
	{
		const data = {
			feedback : null,
			html: this.refs.edit1.getData()
		} ;

        return data ;
	}

	formIsComplete()
	{
		const content = this.refs.edit1.getData() ;

		if ( content.length == 0 )
		{
			return false ;
		}
		else
		{
			return true ;
		}
	}

	onLeave()
	{
		if ( this.props.autoSave == true && this.formIsValid() )
		{
			this.autoSave() ;
		}
	}	
	
	autoSave()
	{
		if ( this.isDirty() == true )
		{
			this.doSave() ;			
		}
	}

	isDirty()
	{
        return this.refs.edit1.isDirty() ;
	}

    setDirty( value )
    {
        if ( this.props.setDirty != null )
        {
            this.props.setDirty(value) ;
        }

        this.refs.edit1.setDirty( false );
    }

	doSave()
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			var reviewData = {} ;

			reviewData.feedback = this.getFormData() ;
			reviewData.progress_review_id = this.props.review_data.progress_review_id ;
			reviewData.child_id = this.props.child_id ;

			this.updateReviewRecords (reviewData) ;
		}
	}

    onChange()
    {
        this.setDirty (true) ;
    }

    onSave()
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			if ( this.props.onSave != null )
			{
				// Just pass the click back to the creating form
				this.props.onSave() ;
			}	
		}
	}

	onCancel() 
	{
		if ( this.props.onCancel != null )
		{
			this.props.onCancel() ;
		}
		else
		{
			location.assign('home.php');
		}
	}
	
	getFormattedDate(date) 
	{
		  var year = date.getFullYear();
		  var month = (1 + date.getMonth()).toString();
		  month = month.length > 1 ? month : '0' + month;
		  var day = date.getDate().toString();
		  day = day.length > 1 ? day : '0' + day;
		  return day + '/' + month + '/' + year;
	}

    rowHTMLNotes ()
    {
        var lineList=[];

		lineList.push ( React.createElement ( 'div',{key: 'titleEdit1Col', className: 'col-md-12', style: { marginBottom: '10px'}},
			React.createElement ( 'span', {
				key: 'text1',
				style: { marginTop: '10px', marginBottom: '10px', fontWeight: 'bold'},
				ref: 'text1' }, "Is there anything else you would like to say about progress for this pupil?" ))) ;

        const config = { height: 500 };

        const events = {};

        lineList.push ( React.createElement ( 'div',{key: 'divEdit1Col', className: 'col-md-12'},
            React.createElement ( LexicalRichTextEditor, {
            	key: 'edit1' + this.keyCount ,
				ref: 'edit1',
				config: config,
				events: events,
				value: this.state.html } ))) ;

        return  React.createElement ( 'div' , { key: 'divEdit1Row', className: 'row' } , lineList );
    }
	
	buttonElement ( buttonText, clickHandler )
	{
        return React.createElement('button', { id: 'getButtonReact', type: 'button', className: 'btn btn-primary', onClick: clickHandler }, buttonText) ;
	}
		
	buttonRow ()
    {
        var lineList=[];
        
        if ( this.props.mode == 'view')
        {
			lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

			lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3', style: { paddingRight: '0px'}},
					 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '0px' }, onClick: this.onCancel.bind(this) }, 'Close')))

        }
        else
        {
			lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

			lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3', style: { paddingRight: '0px'}},
					 React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-primary', style: { float: 'right' } , onClick: this.onSave.bind(this) }, 'Save'),
					 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))
        	
        }
           		        
        return React.createElement('div', { key: this.keyCount++ }, lineList );
    }


	formRows ()
	{
		var lineList=[];
		
		lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'panel-heading' }, 'Feedback'));

        lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'panel-body' }, this.rowHTMLNotes() ));

		lineList.push(this.navFormRow()) ;

		return lineList ;
	}
	
	render() 
    {
		this.keyCount=0;
        return React.createElement('div', { key: this.keyCount++, className: 'panel panel-default panel-subject'}, this.formRows());
    }
};